/**
 * Column registry for the Media list view — drives "Configure the view".
 * `key` matches each antd column's `key` in MediaList.tsx. The leading bulk
 * checkbox column is NOT listed here: it is gated by the "bulk" toggle and
 * always rendered first when bulk is on. Client-hide module.
 * See VIEW_CONFIG_INVENTORY.md §10.
 */

import type { ColumnMeta } from "@/(admin)/components/view-config"
import { t } from "@/languages/i18n"

export const mediaColumnsRegistry: ColumnMeta[] = [
  { key: "url", title: t("Thumbnail"), defaultVisible: true },
  { key: "name", title: t("Name"), defaultVisible: true, alwaysOn: true, sortable: true },
  { key: "createdAt", title: t("Published"), defaultVisible: true, sortable: true },
  { key: "updatedAt", title: t("Last Updated"), defaultVisible: true, sortable: true },
  // Phase 5 — codegen fields (hidden by default). Media uses flat dataIndex
  // (no `attributes` wrapper). `size` is in KB → rendered human-readable.
  { key: "size", title: t("Kích thước"), defaultVisible: true, type: "number", dataIndex: ["size"], sortable: true },
  { key: "ext", title: t("Định dạng"), defaultVisible: false, type: "text", dataIndex: ["ext"], sortable: true },
  { key: "mime", title: t("MIME"), defaultVisible: false, type: "text", dataIndex: ["mime"], sortable: true },
  // Rộng/Cao giữ lại nhưng ẩn mặc định — bật trong "Cấu hình hiển thị" khi cần.
  { key: "width", title: t("Rộng"), defaultVisible: false, type: "number", dataIndex: ["width"], sortable: true },
  { key: "height", title: t("Cao"), defaultVisible: false, type: "number", dataIndex: ["height"], sortable: true },
  {
    key: "alternativeText",
    title: t("Văn bản thay thế"),
    defaultVisible: false,
    type: "text",
    dataIndex: ["alternativeText"],
    sortable: true,
  },
  {
    key: "caption",
    title: t("Chú thích"),
    defaultVisible: false,
    type: "text",
    dataIndex: ["caption"],
    sortable: true,
  },
  {
    key: "folder",
    title: t("Thư mục"),
    defaultVisible: false,
    type: "rel",
    dataIndex: ["folder"],
    queryPopulate: { folder: { fields: ["name"] } },
  },
  { key: "domain", title: t("Tên miền"), defaultVisible: false, type: "text", dataIndex: ["domain"], sortable: true },
  { key: "action", title: t("Action"), defaultVisible: true, alwaysOn: true },
]
